import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import BigImage1 from '../components/BigImage1';
import HomeArticle1 from '../components/HomeArticle1';
import ManutencaoServicos from '../components/ManutencaoServicos';

const Home = () => {
  return (
    <>
    <Helmet>
      <title>Remold Serviços - Manutenção Residencial e Predial</title>
      <meta name='description' content="Portões, Interfone, Elétrica, Reformas, pintura ,elétrica, hidraulica, alvenaria, limpeza caixa d'água limpeza de fossas, instalação de ar-condicionado montagem de móveis" />
      <link rel="canonical" href="/" />
    </Helmet>

    <Container>
      <BigImage1 />
      <HomeArticle1 />
      <ManutencaoServicos />
    </Container>
    </>
 
  )
}

const Container = styled.div`
  
`;

export default Home